import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { IPSService } from '@/services/ipsServices';
import style from '@/views/components/filterItemManager/style.vue';
import addKeyword from '@/views/components/searchRecommend/addKeyword';

@Component({
  mixins: [style],
})
export default class SearchKeywords extends Vue {
  dataList: Array<SearchKeyWord> = [];

  loadingState = false;

  keywords = '';

  @Prop({ default: 0 })
    siteId;

  public selected: Array<SearchKeyWord> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 20;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  async mounted() {
    this.getData();
  }

  getData(): void {
    this.loadingState = true;
    const postParams = {
      siteId: this.siteId,
      type: 1,
      keyword: this.keywords,
      page: this.page,
      pageSize: this.pageSize,
    };
    IPSService.siteKeywordList({
      postParams,
    }).then((res) => {
      this.loadingState = false;
      this.totalCount = res.count;
      this.dataList = res.list.map((i) => {
        i.updateTimeStr = moment(i.updateTime * 1000).format('YYYY-MM-DD HH:mm');
        return i;
      });
    });
  }

  addKeywords(id = 0, desc = {}, keyword = '') {
    addKeyword
      .open({
        data: { desc, type: 1, keyword, id, siteId: this.siteId },
      })
      .then((result) => {
        if (result) {
          this.getData();
        }
      });
  }

  onSearchKeyword(e?) {
    if (e && e.keyCode !== 13) {
      return;
    }
    this.page = 1;
    this.pageSize = 20;
    this.getData();
  }

  public batchDel(id = -1): void {
    let productIds = [];
    let message = '';
    if (id === -1) {
      if (!this.selected || !this.selected.length) {
        return;
      }
      productIds = this.selected.map(v => v.id);
      message = `确认将当前选中的${this.selected.length}个关键词删除？`;
    } else {
      productIds = [id];
      message = '确认将当前选中的关键词删除?';
    }
    this.$confirm(`${message}`, { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        IPSService.siteKeywordDelete({ postParams: { siteId: this.siteId, ids: productIds } }).then((res) => {
          if (res) {
            this.page = 1;
            this.pageSize = 20;
            this.getData();
          }
        });
      }
    });
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getData();
  }

  /**
   * 页码变更
   * @param {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getData();
  }

  // 选中
  onSelected(val) {
    this.selected = val;
  }

  renderTableBtn(h, val) {
    const { id, desc = {}, keyword } = val;
    return (
      <div>
        <span class="scopeSpan" onClick={() => this.addKeywords(id, desc, keyword)}>
          编辑
        </span>
        <span class="scopeSpan" onClick={() => this.batchDel(id)}>
          删除
        </span>
      </div>
    );
  }

  render(h) {
    return (
      <div class="filter-item-list">
        <div class="messageBlock">
          <span class="redText">*&nbsp;</span>
          顾客搜索的关键词与此处配置的搜索关键词完全匹配时，将跳转至指定画面。
        </div>
        <div class="filterController">
          <div class="inputWrapper">
            <el-input
              v-model={this.keywords}
              placeholder="搜索关键词"
              nativeOn-keyup={(e) => {
                this.onSearchKeyword(e);
              }}></el-input>
            <i class="iconfont iconsousuo" onClick={() => this.onSearchKeyword()}></i>
          </div>
        </div>
        <el-table v-loading={this.loadingState} data={this.dataList} element-loading-text="加载中" height={this.$store.state.windowHeight - 322} ref="table" tooltip-effect="light" on-selection-change={this.onSelected}>
          <el-table-column type="selection" width="50" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column type="index" label="#" width="50" align="left" show-overflow-tooltip></el-table-column>
          <el-table-column label="" prop="keyword" max-width="300" show-overflow-tooltip />
          <el-table-column label="链接至" prop="linkToContent" max-width="480" show-overflow-tooltip />
          <el-table-column label="更新人" prop="empName" width="120" show-overflow-tooltip />
          <el-table-column label="更新时间" prop="updateTimeStr" width="160" align="center" show-overflow-tooltip />
          <el-table-column
            label="操作"
            align="center"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scoped) => {
                  return this.renderTableBtn(h, scoped.row);
                },
              },
            }}
          />
        </el-table>
        <div class="hei-21 r-mt-10 r-pb-0 r-pl-10 border-bottom-white">
          <el-button type="primary" onClick={() => this.addKeywords()}>
            添加
          </el-button>
          <span class={[(!this.selected || !this.selected.length) && 'disabled', 'scopeSpan r-mx-16 font-size-14']} onClick={() => this.batchDel()}>
            批量删除
          </span>
          <div class="fr">
            <el-pagination
              on-size-change={this.onSizeChange}
              on-current-change={this.onPageChange}
              current-page={this.page}
              page-sizes={[10, 15, 20, 30]}
              page-size={this.pageSize}
              pager-count={5}
              layout="total, sizes, prev, pager, next, jumper"
              total={this.totalCount}></el-pagination>
          </div>
        </div>
      </div>
    );
  }
}
